import React from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const ManageOrganizationDialog = ({ onClose, onSubmit }) => {
    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>Manage Organization</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <Typography>Do you really want to manage this organization?</Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>No</Button>
                <Button variant="contained" onClick={onSubmit}>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ManageOrganizationDialog.propTypes = {
    onClose: PropTypes.func,
    onSubmit: PropTypes.func
};

export default ManageOrganizationDialog;
